import React from 'react';

import { Typography } from '@mui/material';
import { CircleCheck, Loader } from 'lucide-react';
import { makeStyles } from 'tss-react/mui';

interface PhaseStatusIndicatorStyleProps {
  isActive: boolean;
  isCompleted: boolean;
}

const useStyles = makeStyles<PhaseStatusIndicatorStyleProps>()((theme, { isCompleted }) => ({
  taskBadge: {
    alignItems: 'center',
    border: `1px solid ${isCompleted ? theme.palette.success.main : theme.appColors.primary}`,
    borderRadius: 12,
    color: isCompleted ? theme.palette.success.main : theme.appColors.primary,
    display: 'flex',
    gap: theme.spacing(0.5),
    padding: theme.spacing(0.25, 1),
  },
  taskBadgeText: {
    fontSize: 12,
    fontWeight: 600,
  },
}));

interface PhaseStatusIndicatorProps {
  isActive: boolean;
  isCompleted: boolean;
}

export function PhaseStatusIndicator({ isActive, isCompleted }: PhaseStatusIndicatorProps) {
  const { classes } = useStyles({ isActive, isCompleted });

  if (isCompleted) {
    return (
      <div className={classes.taskBadge}>
        <CircleCheck size={16} />
        <Typography noWrap className={classes.taskBadgeText} variant="body2">
          Phase Complete
        </Typography>
      </div>
    );
  }

  if (isActive) {
    return (
      <div className={classes.taskBadge}>
        <Loader size={14} />
        <Typography noWrap className={classes.taskBadgeText} variant="body2">
          Active
        </Typography>
      </div>
    );
  }

  return null;
}
